import { createSlice } from "@reduxjs/toolkit";

export const name = "phishBox";

export const phishBoxSlice = createSlice({
  name,
  initialState: {
    phishBoxList: [],
    phishBoxListLoading: false,
    phishBoxActiveTab: "Latest",
    phishBoxTabSwitching: false,
    dynamicPhishingEmails: [],
    dynamicPhishingEmailsLoading: false,
    dynamicPhishingActiveTab: "Latest",
    dynamicPhishingTabSwitching: false,
  },
  reducers: {
    SetPhishBoxActiveTab: (state, action) => {
      state.phishBoxActiveTab = action.payload;
      state.phishBoxTabSwitching = true;
    },
    RequestPhishBoxList: (state) => {
      state.phishBoxListLoading = true;
    },
    SuccessPhishBoxList: (state, action) => {
      state.phishBoxList = action.payload;
      state.phishBoxListLoading = false;
      state.phishBoxTabSwitching = false;
    },
    FailurePhishBoxList: (state) => {
      state.phishBoxListLoading = false;
      state.phishBoxTabSwitching = false;
    },
    SetDynamicPhishingActiveTab: (state, action) => {
      state.dynamicPhishingActiveTab = action.payload;
      state.dynamicPhishingTabSwitching = true;
    },
    RequestDynamicPhishingEmails: (state) => {
      state.dynamicPhishingEmailsLoading = true;
    },
    SuccessDynamicPhishingEmails: (state, action) => {
      state.dynamicPhishingEmails = action.payload;
      state.dynamicPhishingEmailsLoading = false;
      state.dynamicPhishingTabSwitching = false;
    },
    FailureDynamicPhishingEmails: (state) => {
      state.dynamicPhishingEmailsLoading = false;
      state.dynamicPhishingTabSwitching = false;
    },
  },
});

export default phishBoxSlice;
